import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import capitalize from 'lodash/capitalize'
import { LayerPopup, Props as LayerPopupProps } from './LayerPopup'
import { useForestGroupQuery } from '@foros-fe/graphql'

type Props = Pick<LayerPopupProps, 'position'> & {
  id: string
}

export const ForestGroupPopup: FC<Props> = ({ position, id }) => {
  const { t } = useTranslation(['forest', 'common'])
  const { data } = useForestGroupQuery({ variables: { id } })

  const forestGroup = data?.forestGroup

  return forestGroup ? (
    <LayerPopup position={position} layer={forestGroup.title} title={t('common:map.forestGroup')}>
      <LayerPopup.Item
        label={capitalize(t('forestGroups'))}
        value={t(`enum:ForestGroupTitle.${forestGroup.title.replace(' ', '')}`)}
      />
    </LayerPopup>
  ) : null
}
